// uat：wwc20795e2b3f16505
// stg：wwc20795e2b3f16505
// stg2：wwc20795e2b3f16505
// prd：wxead7ba7c61cc5a8f

let baseUrl = 'https://login.countrygarden.com.cn', redirectUri= 'http://localhost:6003', clientId = 'sgcgcctg';

let env = process.env.VUE_APP_CURRENTMODE
// let protocol = 'https:'
let protocol = 'https:'
// let protocol = top.location.protocol
switch(env){

    case 'dev':
        baseUrl = `https://login.countrygarden.com.cn`
        redirectUri = `${protocol}//bgy.dev.rscloud.com/`
        clientId = 'sgcgcctg';
        break;
    case 'uat1':
        baseUrl = `http://ssotest.sce-re.com`
        redirectUri = `${protocol}//bgy.dev.rscloud.com/`
        clientId = 'sgcgcctg';
        break;  
    case 'stg':
        baseUrl = `https://login.countrygarden.com.cn`
        redirectUri = `${protocol}//07sg.cgcctg.com/`
        clientId = 'sgcgcctg';
        break;  
    case 'prd':
        baseUrl = `https://login.countrygarden.com.cn`
        redirectUri = `${protocol}//07sg.cgcctg.com/`
        clientId = 'sgcgcctg';
        break;
}
let redirect = {baseUrl, redirectUri, clientId}
export default redirect
